import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getShownTrackTransportsId, getIsTrackShown, hideTrack } from '../../store/mapSlice'

import styles from './HideTrack.module.scss'

export function HideTrackBody({ shownTrackTransportsId, isTrackShown, hideTrack }) {
    const hideTrackCallback = useCallback(() => {
        hideTrack()
    }, [hideTrack])

    if (!shownTrackTransportsId) {
        return null
    }

    return (
        <button type="button" className={styles.button} onClick={hideTrackCallback}>{isTrackShown ? 'Убрать трек' : 'Трек загружается...'}</button>
    )
}

HideTrackBody.propTypes = {
    shownTrackTransportsId: PropTypes.number,
    isTrackShown: PropTypes.bool.isRequired,
    hideTrack: PropTypes.func.isRequired,
}

const HideTrack = connect(
    state => ({
        shownTrackTransportsId: getShownTrackTransportsId(state),
        isTrackShown: getIsTrackShown(state),
    }), {
        hideTrack,
    },
)(HideTrackBody)

HideTrack.propTypes = {}

export { HideTrack }
